var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-tabs",
        {
          attrs: { "background-color": "blue-grey lighten-5" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { key: "currency" }, [_vm._v("Currency")]),
          _c("v-tab", { key: "currency_kind" }, [_vm._v("Kind")]),
          _c("v-tab", { key: "currency_group" }, [_vm._v("Group")]),
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "mt-4",
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab-item", { key: "currency" }, [_c("r-currency-page")], 1),
          _c(
            "v-tab-item",
            { key: "currency_kind" },
            [_c("r-currency-kind-page")],
            1
          ),
          _c(
            "v-tab-item",
            { key: "currency_group" },
            [_c("r-currency-group-page")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }